// Photos du chantier (incrément 5) : prise de photo sur téléphone (input fichier, accept="image/*", capture = appareil arrière),
// aperçu avant envoi, réduction dans le navigateur (≤ 2000 px, JPEG) puis envoi ; vignettes servies par le serveur (404 hors
// chantier). Consigne affichée : photographier l'ouvrage, pas les personnes.
import { useEffect, useState } from 'react';
import { Camera, RotateCcw, X } from 'lucide-react';
import { Bouton } from '../../../components/ui.tsx';
import { BoutonPhoto } from '../../../components/LecturePhoto.tsx';

export const CONSIGNE_PHOTO = 'Photographiez l’ouvrage, pas les personnes. La photo est réduite avant l’envoi.';

/** Champ « photo » : bouton qui ouvre l'appareil photo, aperçu, « Reprendre » et « Retirer ». */
export function ChampPhoto({ libelle, photo, changer, aide }: { libelle: string; photo: File | null; changer: (f: File | null) => void; aide?: string }) {
  const [apercu, setApercu] = useState<string | null>(null);
  useEffect(() => {
    if (!photo) { setApercu(null); return; }
    const u = URL.createObjectURL(photo);
    setApercu(u);
    return () => URL.revokeObjectURL(u);
  }, [photo]);
  return (
    <div className="champ tr-photo">
      <span className="champ-libelle">{libelle}</span>
      {apercu ? (
        <div className="tr-photo-apercu">
          <img src={apercu} alt="Aperçu de la photo choisie" />
          <div className="tr-photo-actions">
            <BoutonPhoto icone={<RotateCcw aria-hidden />} surPhoto={changer}>Reprendre</BoutonPhoto>
            <Bouton variante="fantome" icone={<X aria-hidden />} onClick={() => changer(null)}>Retirer</Bouton>
          </div>
        </div>
      ) : <BoutonPhoto icone={<Camera aria-hidden />} surPhoto={changer}>Prendre la photo</BoutonPhoto>}
      <span className="champ-aide">{aide ?? CONSIGNE_PHOTO}</span>
    </div>
  );
}

/** Rattachement d'une photo : au plus un élément (aucun = photo du jour du chantier). */
export type RattachementPhoto = { etapeId: string } | { reserveId: string } | { pieceId: string } | { noteId: string } | { evenementId: string }
  | { reserveOp: string } | { pieceOp: string } | { cocheOp: string } | { mesureOp: string } | Record<string, never>;

// L'envoi d'une photo passe par la file d'envoi (incrément 6) : saisie.ts > operationPhoto (réduite AVANT d'être gardée), puis
// lib/fileEnvoi.ts (une par une, après les autres saisies ; même identifiant d'envoi = aucun doublon).

export const urlPhoto = (chantierId: string, pid: string) => `/api/chantiers/${chantierId}/photos/${pid}`;

/** Vignettes cliquables (ouvrent la photo en grand dans un nouvel onglet). */
export function VignettesPhotos({ chantierId, photos, libelle }: { chantierId: string; photos: { id: string }[]; libelle: string }) {
  if (!photos.length) return null;
  return (
    <ul className="tr-vignettes" aria-label={`Photos — ${libelle}`}>
      {photos.map((p, i) => (
        <li key={p.id}>
          <a href={urlPhoto(chantierId, p.id)} target="_blank" rel="noopener" aria-label={`Ouvrir la photo ${i + 1} (${libelle}) en grand`}>
            <img src={urlPhoto(chantierId, p.id)} alt={`Photo ${i + 1} — ${libelle}`} loading="lazy" />
          </a>
        </li>
      ))}
    </ul>
  );
}
